// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"9e71cb5e","672":"51f3537c","809":"07c2f3c0","875":"bf2cf76f","928":"bf2cf76f"}[chunkId] + ".chunk.css";
};